'use strict';

/*global DEBUG */

function isEmpty(obj) {
   if (typeof obj === 'undefined' || obj === null || obj === '') {
       return true;
   }
   if (typeof obj === 'number' && isNaN(obj)) {
       return true;
   }
   if (obj instanceof Date && isNaN(Number(obj))) {
       return true;
   }
   return false;
}

function varDump(obj, target) {
    var out = '';
    for(var i = 0; i < obj.length; i++) {
        out += i + ': ' + obj[i] + '\n';
    }
    if(isEmpty(target) || target === 'console') {
        console.log(out);
    } else 
    if(target === 'body') {   
        var pre = document.createElement('pre');
        pre.innertHtml = out;
        document.body.appendChild(pre);
    } else
    if(target === 'alert') {
        alert(out);        
    }
}

function echo(str, target) {
    if(isEmpty(target) || target === 'console') {
        console.log(str);
    } else 
    if(target === 'body') {   
        var pre = document.createElement('pre');
        pre.innertHtml = str;
        document.body.appendChild(pre);
    } else
    if(target === 'alert') {
        alert(str);        
    }
}

// odblokuje element
function unBlockElement(element) {
    element.removeClass('uiBlockerParent').find('.blocker').remove();
}

// zablokuje element prekryvnym divem
function blockElement(element) {
    unBlockElement(element);
    element.addClass('uiBlockerParent')
           .append('<div class="blocker">').find('.blocker').append($('<div class="loader" />').append('<span class="bar"></span><span class="bar"></span><span class="bar"></span>'));
}

function viewPageErrorMsg() {
    $('#pageErrorMsg').show();
    
    if(DEBUG) {
        var stack = new Error().stack;
        echo('PRINTING CALL STACK');
        echo(stack);
    }
}

var savedInfoTimeout = null;
function viewPageSavedMsg() {
    $('#pageSavedMsg').removeClass('hvr-ripple-out').removeClass('autostart');
    $('#pageSavedMsg').fadeIn('slow', function () {
        $('#pageSavedMsg').addClass('hvr-ripple-out').addClass('autostart');
    });
    clearTimeout(savedInfoTimeout);
    savedInfoTimeout = setTimeout(function () {
        $('#pageSavedMsg').fadeOut('slow');    
    }, 3000);
}

function isArray(object) {
    if(Object.prototype.toString.call(object) === '[object Array]') {
        return true;
    }
    return false;
}

function removeDiak(str) {
  var withDiak = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ'; 
  var withOutdiak = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ';
   
  var newStr = ''; 
  for(var i = 0; i < str.length; i++) { 
    if(withDiak.indexOf(str.charAt(i)) !== -1) { 
      newStr += withOutdiak.charAt(withDiak.indexOf(str.charAt(i))); 
    } else { 
      newStr += str.charAt(i);
    } 
  } 
  return newStr;
}

function capitalize(s) {
    return s && s[0].toUpperCase() + s.slice(1);
}

function compareDates(str1, str2) { 
    var dt1   = parseInt(str1.substring(0, 2), 10); 
    var mon1  = parseInt(str1.substring(3, 5), 10);
    var yr1   = parseInt(str1.substring(6, 10), 10); 
    var dt2   = parseInt(str2.substring(0, 2), 10); 
    var mon2  = parseInt(str2.substring(3, 5), 10); 
    var yr2   = parseInt(str2.substring(6, 10), 10); 
    mon1 = mon1 - 1;
    mon2 = mon2 - 1;
    var date1 = new Date(yr1, mon1, dt1); 
    var date2 = new Date(yr2, mon2, dt2); 
    if(date2 < date1) {
        return false; 
    } else { 
        return true;
    } 
} 

function setDBCookie(name, value, async) {
    if(isEmpty(async)) {
        async = true;
    }
    
    $.ajax({
         url: '/admin/DBCookies/set_cookie/',
         type: 'POST',  
         data: { name: name, value: value },
         async: async,
         success: function (result) {
             if (result.isOk === false) {
                 echo('error');
             }                 
         },
    }); 
}

function getDBCookie(name) {
    var ret = null;
    $.ajax({
        url: '/admin/DBCookies/get_cookie/',
        data: { name: name },
        async: false,
        success: function (result) {
            ret = result;
        }
    });
    return ret;
}

// uložení cookie
function setCookie(name, value) {
    setDBCookie(name, value);
}

// načtení cookie
function getCookie(name) {
    return getDBCookie(name);
}

function getObjectName(object) { 
   var funcNameRegex = /function (.{1,})\(/;
   var results = (funcNameRegex).exec((object).constructor.toString());
   return (results && results.length > 1) ? results[1] : '';
}

function isTouchDevice() {
  return 'ontouchstart' in window || 'onmsgesturechange' in window; // works on most browsers || works on ie10
}

function createCallBack(object, func) {    
    return function (param1, param2) {
        object[func](param1, param2);
    };
}

function createCallBack2(object, func, param2) {
    return function (param1) {        
        func(param1, this, object, param2);
    };
}

function createCallBack3(object, func, param3) {    
    return function (param1, param2) {
        object[func](param1, param2, param3);
    };
}

function doBackstretch() {
    jQuery('.doBackstretch:not(.hasBackstretch)').each(function () {
        jQuery(this).addClass('hasBackstretch');
        jQuery(this).backstretch(jQuery(this).find('img').attr('src'));
        jQuery(this).find('img').css('display', 'none');        
    });
}

function updateTextareas(textareaList) {
    textareaList.each(function () {
        jQuery(this).height(0).height(jQuery(this).prop('scrollHeight'));
    });
}

function getPosition(el) {
  var xPos = 0;
  var yPos = 0;
 
  while(el) {
    if(el.tagName === 'BODY') {
      // deal with browser quirks with body/window/document and page scroll
      var xScroll = el.scrollLeft || document.documentElement.scrollLeft;
      var yScroll = el.scrollTop || document.documentElement.scrollTop;
 
      xPos += (el.offsetLeft - xScroll + el.clientLeft);
      yPos += (el.offsetTop - yScroll + el.clientTop);
    } else {
      // for all other non-BODY elements
      xPos += (el.offsetLeft - el.scrollLeft + el.clientLeft);
      yPos += (el.offsetTop - el.scrollTop + el.clientTop);
    }
 
    el = el.offsetParent;
  }
  return {
    x: xPos,
    y: yPos
  };
}

function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
}
